import React from 'react'
import {StaticQuery, graphql} from 'gatsby'
import Img from 'gatsby-image'

const ImageBar = () => (
    <StaticQuery
    query={graphql`
        {
            background: imageSharp(original: {src: {regex: "/sime-basioli-BRkikoNP0KQ-unsplash/"}}) {
                fluid(maxWidth: 1920, maxHeight: 550, cropFocus: ENTROPY) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    `}
    render={ data => (
        <Img fluid={data.background.fluid} alt="water" className="imageBar" />
    )}
    />
)

export default ImageBar